import { useState } from 'react';

const useVisibleColumns = (defaultValue = []) => {
  return useState(defaultValue);
};

export default useVisibleColumns;
